export default __webpack_public_path__ + "static/media/coder.3f53d42f.svg";